import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import './styles.styl';

const sumScores = scores => {
  return Object.keys(scores).reduce((sum, path) => {
    return sum + scores[path];
  }, 0);
};

const ModuleFeedback = (
  {
    scores,
    possibleScores,
    children,
    data
  }) => {
  const totalScore = sumScores(scores);
  // const totalPossibleScore = sumScores(possibleScores);
  
  const renderMessage = () => {
    if (totalScore >= data.badgeThreshold) {
      return data.badgeSuccess
    } else {
      return data.badgeFailure;
    }
  };
  
  return (
    <Fragment>
      {
        renderMessage()
      }
      { children }
    </Fragment>
  )
};

ModuleFeedback.propTypes = {
  scores: PropTypes.object
};

export default ModuleFeedback;



// WEBPACK FOOTER //
// ../core/src/components/ModuleFeedback/ModuleFeedback.js